export enum TariffRoutes {
  Tariffs = '/tariff/',
}
